import { Action } from 'redux';

export const setDisconnected = (): Action<string> => ({
  type: 'DISCONNECTED',
});

export const setConnected = (): Action<string> => ({
  type: 'CONNECTED',
});
